import store from '@carvana/purchase-store';
import * as Services from '../services';
import * as types from './action-types';

export const CancelOrder = () =>
  store.dispatch({
    type: types.CANCEL_ORDER,
    payload: Services.cancelOrder({ reasons: ['CustomerSelfCancelled'] })
  });

export const EditOrder = payload =>
  store.dispatch({
    type: types.EDIT_ORDER,
    payload: Services.editOrder(payload)
  });

export const FetchOrderOptions = () =>
  store.dispatch({
    type: types.ORDER_OPTIONS_FETCH,
    payload: Services.fetchOrderOptions()
  });

export const FetchOrderSummary = () =>
  store.dispatch({
    type: types.ORDER_SUMMARY_FETCH,
    async payload() {
      return Services.fetchOrderSummary();
    }
  });

export const GetTransferScheduleTimeslots = () => dispatch =>
  dispatch({
    type: types.GET_TRANSFER_SCHEDULE_TIMESLOTS,
    async payload() {
      return Services.getTransferScheduleTimeslots();
    }
  });

export const SelectTimeSlotDate = payload => {
  return store.dispatch({
    type: types.TIME_SLOT_DATE_SELECTED,
    payload
  });
};

export const SelectTimeSlotTime = payload =>
  store.dispatch({
    type: types.TIME_SLOT_TIME_SELECTED,
    payload
  });

export const SubmitSelectedTimeSlot = payload =>
  store.dispatch({
    type: types.TIME_SLOT_SUBMIT,
    payload() {
      return Services.submitSelectedTimeSlot(payload);
    }
  });

export const CloseRescheduleModal = () =>
  store.dispatch({
    type: types.RESCHEDULE_MODAL_CLOSED
  });
